export const mapInput = (input, props) => ({
  ...props,
  ...(typeof input === 'function' ? input(props) : input)
});

export default mapInput;